import { FormObjType } from "DataTypes/Form";

export const VitalForm: FormObjType[] = [
  {
    id: "vitalName",
    label: "Vital Name",
    placeholder: "Enter Vital Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "vitalSignDatetime",
    label: "Vital Sign Date",
    placeholder: "Select Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "vitalValue",
    label: "Vital Value",
    placeholder: "Enter Vital Value",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "vitalUnits",
    label: "Vital Unit",
    placeholder: "Enter Vital Unit",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "targetSitename",
    label: "Target Site / Method",
    placeholder: "Enter Target Site / Method",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    enableFormLoad: true,
  },
  {
    id: "interpretation",
    label: "Interpretation",
    placeholder: "Enter Interpretation",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    enableFormLoad: true,
  },
  {
    id: "status",
    label: "Status",
    placeholder: "Enter Status",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    enableFormLoad: true,
  },
]
